import "./Blog.scss";

class Page {

	/**
	 * @arg {object} opts — Options
	 * @constructor
	 */
	constructor(opts = {}) {

	}
	
	/** Need this to run after DOM ready? Put scripts here */
	init() {
		
	}
}

window.Zero = window.Zero || {};
window.Zero.page = new Page();